import { isEmpty } from "lodash";

const addError = (element: HTMLElement): void => {
  if (!element.classList.contains("has-error")) {
    element.classList.add("has-error");
  }
}

const isVisible = (element: HTMLElement): boolean => {
  return element && element.style.display !== "none";
}

const hide = (element: HTMLElement): void => {
  if (isVisible(element))
    element.style.display = "none";
}

const removeError = (element: HTMLElement): void => {
  if (element.classList.contains("has-error")) {
    element.classList.remove("has-error");
  }
}

const show = (element: HTMLElement): void => {
  if (!isVisible(element))
    element.style.display = "";
}

interface Validator {
  handleInvalidated: () => void;
  handleValidated: () => void;
  input: HTMLInputElement;
  valid: boolean;
}

class NotEmptyValidator implements Validator {
  private _input: HTMLInputElement;
  private _inputRow: HTMLElement;

  constructor(inputId: string) {
    this._input = document.getElementById(inputId) as HTMLInputElement;
    this._inputRow = document.getElementById(`${inputId}-row`);
  }

  public handleInvalidated(): void {
    addError(this._inputRow);
  }

  public handleValidated(): void {
    removeError(this._inputRow);
  }

  public get input(): HTMLInputElement {
    return this._input;
  }

  public get valid(): boolean {
    return this._input && !isEmpty(this._input.value);
  }
}

class FormValidation {
  private _form: HTMLFormElement;
  private _validators: Validator[];

  constructor(formId: string, validators: Validator[]) {
    this._form = document.getElementById(formId) as HTMLFormElement;
    this._form.addEventListener("submit", this.handleFormSubmit);
    this._validators = validators;
    this._validators.forEach((v) => {
      v.input.addEventListener("input", () => this.handleInputChange(v));
    });
  }

  private handleInputChange = (validator: Validator): void => {
    if (validator.valid) {
      validator.handleValidated();
    } else {
      validator.handleInvalidated();
    }
  }

  private handleFormSubmit = (e: Event): void => {
    e.preventDefault();
    e.stopPropagation();

    let invalid = false;
    this._validators.forEach((v) => {
      if (v.valid) {
        v.handleValidated();
      } else {
        invalid = true;
        v.handleInvalidated();
      }
    });
    if (!invalid) {
      this._form.submit();
    }
  }
}

export {
  addError,
  FormValidation,
  isVisible,
  hide,
  NotEmptyValidator,
  removeError,
  show,
  Validator,
};
